import { MinusIcon, PanelRightCloseIcon, PanelRightOpenIcon, XIcon } from "lucide-react";

import type { ProjectLeadCompanionDock } from "../projectLeadCompanionState";
import { RESPONSIVE_ICON_BUTTON_CLASS } from "../lib/touchTarget";
import { Button } from "./ui/button";

export function ProjectLeadCompanionControls(props: {
  readonly surface: "global" | "task-dialog";
  readonly dock: ProjectLeadCompanionDock;
  readonly onClose: () => void;
  readonly onMinimize: () => void;
  readonly onDockChange: (dock: ProjectLeadCompanionDock) => void;
}) {
  const nextDock = props.dock === "right" ? "floating" : "right";
  return (
    <div className="flex items-center gap-[8px] md:gap-1" data-no-drag>
      {props.surface === "global" ? (
        <Button
          aria-label={
            nextDock === "right" ? "Dock Project Lead to the right" : "Float Project Lead"
          }
          className={RESPONSIVE_ICON_BUTTON_CLASS}
          size="icon-xs"
          variant="ghost"
          onClick={() => props.onDockChange(nextDock)}
        >
          {nextDock === "right" ? (
            <PanelRightOpenIcon aria-hidden />
          ) : (
            <PanelRightCloseIcon aria-hidden />
          )}
        </Button>
      ) : null}
      <Button
        aria-label="Minimize Project Lead"
        className={RESPONSIVE_ICON_BUTTON_CLASS}
        size="icon-xs"
        variant="ghost"
        onClick={props.onMinimize}
      >
        <MinusIcon aria-hidden />
      </Button>
      {props.surface === "global" ? (
        <Button
          aria-label="Close Project Lead"
          className={RESPONSIVE_ICON_BUTTON_CLASS}
          size="icon-xs"
          variant="ghost"
          onClick={props.onClose}
        >
          <XIcon aria-hidden />
        </Button>
      ) : null}
    </div>
  );
}
